(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TradePolicyRuleEffectDeleteController',TradePolicyRuleEffectDeleteController);

    TradePolicyRuleEffectDeleteController.$inject = ['$uibModalInstance', 'entity', 'TradePolicyRuleEffect'];

    function TradePolicyRuleEffectDeleteController($uibModalInstance, entity, TradePolicyRuleEffect) {
        var vm = this;
        vm.tradePolicyRuleEffect = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TradePolicyRuleEffect.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
